import { useQuery } from "@tanstack/react-query";
import useAxiosPrivate from "@/hooks/useAxiosPrivate";

interface PastPurchaseItem {
  product_id: number;
  product_quantity: number | null;
}

interface PastPurchasesResponse {
  data: Record<string, PastPurchaseItem[]>;
  analytics: Record<string, any>;
}

export const usePastPurchases = (customerId: string | null | undefined) => {
  const axiosPrivate = useAxiosPrivate();

  return useQuery<Set<string>>({
    queryKey: ["pastPurchases", customerId],
    queryFn: async () => {
      if (!customerId) return new Set<string>();

      const response = await axiosPrivate.get<PastPurchasesResponse>(
        `/customers/pastPurchases/${customerId}`
      );

      const allItems = Object.values(response.data?.data ?? {}).flat();
      const productIds = allItems.map((item) => String(item.product_id));

      return new Set(productIds);
    },
    enabled: !!customerId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};

export default usePastPurchases;
